import styled from "styled-components";

export default c => styled(c)`
  .email-template .text-field--element {
    height: 200px;
  }

  .additional-message-template .text-field--element {
    height: 90px;
  }

  .informations {
    display: inline-flex;
    align-items: center;
    margin-top: 10px;
  }

  .message {
    padding-left: 6px;
    font-weight: bolder;
    font-size: 17px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/app/registration/company/view/general-info/style.js